var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisabledVisibleGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 15C17.95 15 19.76 15.98 20.75 17.5C19.76 19.02 17.95 20 16 20C14.05 20 12.24 19.02 11.25 17.5C12.24 15.98 14.05 15 16 15ZM16 13C12.82 13 10.1 14.87 9 17.5C10.1 20.13 12.82 22 16 22C19.18 22 21.9 20.13 23 17.5C21.9 14.87 19.18 13 16 13ZM16 19C15.17 19 14.5 18.33 14.5 17.5C14.5 16.67 15.17 16 16 16C16.83 16 17.5 16.67 17.5 17.5C17.5 18.33 16.83 19 16 19ZM20.99 12.34C21 12.23 21 12.11 21 12C21 6.48 16.52 2 11 2C5.48 2 1 6.48 1 12C1 17.17 4.93 21.43 9.96 21.95C9.03 21.22 8.24 20.31 7.64 19.27C4.9 18 3 15.22 3 12C3 10.15 3.63 8.45 4.69 7.1L10.35 12.76C10.91 12.36 11.52 12.03 12.17 11.76L6.1 5.69C7.45 4.63 9.15 4 11 4C15.24 4 18.7 7.29 18.98 11.45C19.69 11.67 20.37 11.97 20.99 12.34Z",
    fill: "#7A89A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledVisibleGray);
export default __webpack_public_path__ + "static/media/disabled_visible_gray.a924a717caca3cb715cc5c5f750cf194.svg";
export { ForwardRef as ReactComponent };